/**
 * 接口配置
 */
import $https from "./index";
import store from "../store";
// 登录

export const getPermission = () => {
  return $https.get(`/vkcms/api/v1/user/getPermission`);
};
// 退出登录
export const logout = () => {
  return $https.get(`/vkcms/api/v1/user/logout`);
};
// h5---------------------------------------------
// 数据详情页
export const queryForStory = (projectCode) => {
  return $https.get(
    `/vkcms/api/v1/h5/metrics/queryForStory?projectCode=${projectCode}`,
    {
      headers: {
        userId: store.state.userId || localStorage.getItem("userId") || "",
      },
    }
  );
};
// 报告评价
export const evaluate = (data) => {
  return $https.post(`/vkcms/api/h5/story/evaluate`, data, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
//项目列表
export const projectList = (params) => {
  return $https.get(`/vkcms/api/v1/user/getProject`, { params });
};
// 项目列表模糊搜索
export const queryProPullDown = (params) => {
  return $https.post(`/vkcms/api/v1/project/queryProPullDown`,params);
};
//创建故事
export const createStory = (data) => {
  return $https.post(`/vkcms/api/v1/story/add`, data);
};
//故事详情
export const storyDetail = (params) => {
  return $https.get(`/vkcms/api/v1/story/detail`, { params });
};
//删除故事
export const deleteStory = (params) => {
  return $https.delete(`/vkcms/api/v1/story/delete`, { params });
};
//故事上下架
export const upDownStory = (params) => {
  return $https.get(`/vkcms/api/v1/story/upDown`, { params });
};
//故事列表
export const storyList = (data) => {
  return $https.post(`/vkcms/api/v1/story/list`, data);
};
// 是否开启对客展示开关
export const queryConfig = (params) => {
  return $https.get(`/vkcms/api/v1/project/queryConfig`, { params });
};
// 更新对客展示开关
export const udateConfig = (data) => {
  return $https.post(`/vkcms//api/v1/project/udateConfig`,data);
};
//获取OA审核URL
export const toOA = (data) => {
  return $https.post(`/vkcms/api/v1/story/getApproveUrl`, data, {
    headers: {
      errorHandle: false,
    },
  });
};
//获取OA审核URL
export const getApproveUrlClose = (data) => {
  return $https.get(`/vkcms/api/v1/story/getApproveUrlClose?projectCode=${data.projectCode}&workNo=${data.workNo}`, {
    headers: {
      errorHandle: false,
    },
  });
};
//指标树
export const cellTree = (data) => {
  return $https.post(`/vkcms/api/v1/metrics/list`, data);
};
// 创建故事第二页保存
export const saveStoryTwo = (data) => {
  return $https.post(`/vkcms/api/v1/story/update`, data);
};
// 创建故事第三页保存
export const saveStoryThree = (data) => {
  return $https.post(`/vkcms/api/v1/story/updateMetrics`, data);
};
// 获取第三页指标数据
export const queryForStory1 = (params) => {
  return $https.get(`/vkcms/api/v1/story/queryForStory`, { params });
};
// c端故事详情
export const getDetailM = (params) => {
  return $https.post(`/vkcms/api/h5/story/detail`, params, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// // getTicketSelector
// export const getTicketSelector = (data) => {
//   return $https.post(`/vkcms/api/h5/story/getTicketSelector`, data, {
//     headers: {
//       k2approval: "ApprovalALL",
//     },
//   });
// };
// c端登录
export const loginMobile = (params) => {
  return $https.post(`/vkcms/api/h5/user/login`, params);
};
// C端获取指标
export const queryForStoryM = (params) => {
  return $https.get(`/vkcms/api/h5/story/queryForStory`, {
    params,
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};

//新增指标
export const addCell = (data) => {
  return $https.post(`/vkcms/api/v1/metrics/add`, data);
};
//删除指标
export const remvoeCell = (params) => {
  return $https.get(`/vkcms/api/v1/metrics/delete`, { params });
};
//修改指标名称
export const updateCell = (data) => {
  return $https.post(`/vkcms/api/v1/metrics/update`, data);
};
//指标值查询
export const cellDataList = (data) => {
  return $https.post(`/vkcms/api/v1/metrics/value/queryList`, data);
};
//特定指标值 PR0028 查询
export const specialCellDataList = (data) => {
  return $https.post(`/vkcms/api/v1/metrics/value/queryPr0028List`, data);
};
//指标值修改
export const cellValueUpdate = (data) => {
  return $https.post(`/vkcms/api/v1/metrics/value/update`, data);
};

//导入指标列表
export const importCellList = (data) => {
  return $https.post(`/vkcms/api/v1/metrics/import/list`, data);
};

//线下指标树
export const offLineTree = (data) => {
  return $https.post(`/vkcms/api/v1/metrics/listOffline`, data);
};
//线下导入指标删除
export const offLineCellDelete = (params) => {
  return $https.get(`/vkcms/api/v1/metrics/import/delete`, { params });
};

//下载导入模板
export const downloadOfflineTemplate = (data) => {
  return $https.post(
    `/vkcms/api/v1/metrics/import/downloadOfflineTemplate`,
    data,
    { responseType: "blob" }
  );
};
// 设备工单查询
export const listTickets = (params) => {
  return $https.post(`/vkcms/api/h5/story/listTickets`, params, {
    headers: {
      k2approval: "ApprovalALL",
    },
  });
};
// 祝英台工单查询
export const listZytTickets = (params) => {
  return $https.post(`/vkcms/api/h5/story/listZytTickets`, params, {
    headers: {
      k2approval: "ApprovalALL",
    },
  });
};
// 电梯设备明显查询
export const getElevator = (data) => {
  return $https.post(`/vkcms/api/h5/story/lastMaintenance`, data, {
    headers: {
      k2approval: "ApprovalALL",
    },
  });
};
// sop img
export const fmOdTaskSop = (data) => {
  return $https.get(
    `/vkcms/api/h5/story/fmOdTaskSop?taskNo=${data.taskNo}&businessTime=${data.businessTime}`,
    {
      headers: {
        userId: store.state.userId || localStorage.getItem("userId") || "",
      },
    }
  );
};
// fmsop step
export const fmPmTaskSop = (data) => {
  return $https.get(
    `/vkcms/api/h5/story/fmPmTaskSop?taskNo=${data.taskNo}&businessTime=${data.businessTime}`,
    {
      headers: {
        userId: store.state.userId || localStorage.getItem("userId") || "",
      },
    }
  );
};

//FM周期性工单步骤
export const queryFmPmTaskSop = (params) => {
  return $https.get(`/vkcms/api/h5/story/fmPmTaskSop`, {
    params,
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
//sys=3工单步骤
export const combinationTaskStepFn = (params) => {
  return $https.get(`/vkcms/api/h5/story/combinationTaskStep`, {
    params,
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
//FM临时性工单步骤
export const queryFmOdTaskSop = (params) => {
  return $https.get(`/vkcms/api/h5/story/fmOdTaskSop`, {
    params,
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};

//飞鸽周期性工单步骤
export const queryFGPmTaskSop = (params) => {
  return $https.get(`/vkcms/api/h5/story/feigePmTaskSop`, {
    params,
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};

//飞鸽临时性工单步骤
export const queryFGOdTaskSop = (params) => {
  return $https.get(`/vkcms/api/h5/story/feigeOdTaskSop`, {
    params,
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
//百川临时性工单步骤
export const queryBCOdTaskSop = (params) => {
  return $https.get(`/vkcms/api/h5/story/baichuanStep`, {
    params,
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 飞鸽 step
export const feigePmTaskSop = (data) => {
  return $https.get(
    `/vkcms/api/h5/story/feigePmTaskSop?taskNo=${data.taskNo}&businessTime=${data.businessTime}`,
    {
      headers: {
        userId: store.state.userId || localStorage.getItem("userId") || "",
      },
    }
  );
};
// getTicketSelector
export const getTicketSelector = (data) => {
  return $https.post(`/vkcms/api/h5/story/getTicketSelector`, data, {
    headers: {
      k2approval: "ApprovalALL",
    },
  });
};
// getZytTicketSelector
export const getZytTicketSelector = (data) => {
  return $https.post(`/vkcms/api/h5/story/getZytTicketSelector`, data, {
    headers: {
      k2approval: "ApprovalALL",
    },
  });
};
// like
export const queryUserReviews = (data) => {
  return $https.post(`/vkcms/api/h5/story/queryUserReviews`, data, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 点赞
export const userclick = (data) => {
  return $https.post(`/vkcms/api/h5/story/click`, data, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 踩
export const userstep = (data) => {
  return $https.post(`/vkcms/api/h5/story/step`, data, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 评论
export const usercomment = (data) => {
  return $https.post(`/vkcms/api/h5/story/comment`, data, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 反馈
export const feedback = (data) => {
  return $https.post(`/vkcms/api/h5/story/feedback`, data, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 反馈列表
export const feedbackList = (data) => {
  return $https.post(`/vkcms/api/h5/story/feedbackList`, data, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 加积分
export const zzeScene = (data) => {
  return $https.post(`/vkcms/api/h5/story/zzeScene`, data, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 已开通服务报告项目列表
export const proList = (data) => {
  return $https.get(`/vkcms/api/h5/story/proList`, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
export const listPassStory = (data) => {
  return $https.get(`/vkcms/api/h5/story/listPassStory?projectCode=${data}`, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// b端查询客户声音列表
export const feedbackListB = (data) => {
  return $https.post(`/vkcms/api/v1/storyFeed/feedbackList`, data);
};
// b端回复客户声音
export const replyFeedback = (data) => {
  return $https.post(`/vkcms/api/v1/storyFeed/replyFeedback`, data);
};
// 导出客户声音
export const exportFeedbackList = (data) => {
  return $https.post(`/vkcms/api/v1/storyFeed/exportFeedbackList`, data, {
    responseType: "blob",
  });
};
// 导出数据看板
export const exportVisitCounts = (data) => {
  return $https.post(`/vkcms/api/v1/view/exportVisitCounts`, data, {
    responseType: "blob",
  });
};
// b端客户评价
export const getEvaluateList = (data) => {
  return $https.post(`/vkcms/api/v1/storyEvaluate/evaluateList`, data);
};
// 阵地列表
export const queryPositionPullDown = (data) => {
  return $https.get(`/vkcms/api/v1/project/queryPositionPullDown?positionName=${data}`);
};
// b端客户评价导出
export const exportEvaluateList = (data) => {
  return $https.post(`/vkcms/api/v1/storyEvaluate/exportEvaluateList`, data, {
    responseType: "blob",
  });
};
// b端数据看板
export const qryVisitCounts = (data) => {
  return $https.post(`/vkcms/api/v1/view/qryVisitCounts`, data);
};
// b端数据看板下拉选项
export const qryVisitSelectors = () => {
  return $https.get(`/vkcms/api/v1/view/qryVisitSelectors`);
};
// 查询指标显示状态
export const getMetricsStatus = (params) => {
  return $https.get(`/vkcms/api/v1/metrics/status/get`, { params });
};

export const updateMetricsStatus = (data) => {
  return $https.post(`/vkcms/api/v1/metrics/status/update`, data);
};

// 上传图片
export const upload = (data) => {
  return $https.post(`/vkcms/api/h5/story/imgUpload`, data, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 项目上线进度监控
export const progressMonitor = (data) => {
  return $https.post(`/vkcms/api/v1/story/progressMonitor`, data);
};
// 导出项目上线进度监控
export const exportProgressMonitor = (data) => {
  return $https.post(`/vkcms/api/v1/story/exportProgressMonitor`, data, {
    responseType: "blob",
  });
};
// 服务报告管理
export const queryProManagerConfig = (data) => {
  return $https.post(`/vkcms/api/v1/project/queryProManagerConfig`, data);
};
// 更新服务报告给模块管理权限
export const updateProManagerConfig = (data) => {
  return $https.post(`/vkcms/api/v1/project/updateProManagerConfig`, data);
};
//更新月份报告展示权限

export const updateCanView = (data) => {
  return $https.post(`/vkcms/api/v1/story/updateCanView`, data);
};
// 多品牌下拉
export const qryBrandSelects = (params) => {
  return $https.post(`/vkcms/api/v1/branPic/qryBrandSelects`,params);
};
// 多品牌查询
export const qryList = (params) => {
  return $https.post(`/vkcms/api/v1/branPic/qryList`,params);
};
// 多品牌更新
export const branPicupdate = (params) => {
  return $https.post(`/vkcms/api/v1/branPic/update`,params);
};
// 品牌logo查询
export const qryProBrand = (params) => {
  return $https.get(`/vkcms/api/v1/branPic/qryProBrand?projectCode=${params}`);
};
// 新增指标
export const addInfo = (params) => {
  return $https.post(`/vkcms/api/v1/work/addInfo`,params);
};
// 更新指标
export const updateInfo = (params) => {
  return $https.post(`/vkcms/api/v1/work/updateInfo`,params);
};
// 指标列表
export const workqryList = (params) => {
  return $https.post(`/vkcms/api/v1/work/qryList`,params);
};
// 工单指标模块配置
// 指标模块下拉
export const qryModuleSelects = (params) => {
  return $https.get(`/vkcms/api/v1/proWork/qryModuleSelects?moduleName=${params}`);
};
// 工单指标模块配置
// 二级分类下拉
export const qryCategorySelects = (params) => {
  return $https.get(`/vkcms/api/v1/proWork/qryCategorySelects?businessType=${params.businessType}&categoryName=${params.categoryName}`);
};
// 新增工单名称下拉
export const qryWorkInfoSelects = (params) => {
  return $https.post(`/vkcms/api/v1/work/qryWorkInfoSelects`,params);
};
// 列表
export const proWorkqryList = (params) => {
  return $https.post(`/vkcms/api/v1/proWork/qryList`,params);
};
// 5、指标模块下新增工单
export const proWorkadd = (params) => {
  return $https.post(`/vkcms/api/v1/proWork/add`,params);
};
// 5、指标模块下删除工单
export const proWorkdelete = (params) => {
  return $https.post(`/vkcms/api/v1/proWork/delete`,params);
};
// 服务报告是否可见
export const busiSetting = (params) => {
  return $https.post(`/vkcms/api/v1/proWork/busiSetting`,params);
};
// 获取全局自动发布开关

export const querySetting = (params) => {
  return $https.get(`/vkcms/api/v1/project/querySetting?projectCode=0 `);
};
// 查询当前用户身份
export const isZzeVisit = (data) => {
  return $https.get(`/vkcms/api/h5/story/isZzeVisit?projectCode=${data.projectCode}&mobile=${data.mobile}`, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 查询当前用户身份
export const isZzeKf = (data) => {
  return $https.get(`/vkcms/api/h5/story/isZzeKf?projectCode=${data.projectCode}&mobile=${data.mobile}`, {
    headers: {
      userId: store.state.userId || localStorage.getItem("userId") || "",
    },
  });
};
// 数据是否刷完
export const judgeFlushed = (params) => {
  return $https.get(`/vkcms/api/v1/story/judgeFlushed?storyId=${params}`);
};

// pc 上传图片
export const uploadPc = (data) => {
  return $https.post(`/vkcms/api/v1/story/imgUpload`, data);
};

// 添加大屏
export const addBigScreen = (data) => {
  return $https.post(`/vkcms/api/v1/screen/add`, data);
};  

// 查询大屏
export const qryBigScreen = (params) => {
  return $https.get(`/vkcms/api/v1/screen/qryScreenInfo?projectCode=${params}`);
}; 


// 查询黑猫公益收入
export const qryHmIncome = (params) => {
  return $https.get(`/vkcms/api/v1/screen/qryHmIncome?projectCode=${params}`);
}; 

// 获取OA审核URL
export const getApproveUrl = (data) => {
  return $https.post(`/vkcms/api/v1/screen/getApproveUrl?screenId=${data.screenId}&workNo=${data.workNo}`, );
}; 

// 黑猫公益收入
export const hmIncome = (data) => {
  return $https.post(`/vkcms/api/v1/screen/hmIncome`, data);
}; 

// 修改大屏
export const updateBigScreen = (data) => {
  return $https.post(`/vkcms/api/v1/screen/update`, data);
};  

export const getQryH5ScreenInfo = (data) => {
  return $https.get(`/vkcms/api/h5/screen/qryScreenInfo?projectCode=${data}`);
};  

// 获取工单
export const getWorkOrder = (params) => {
  return $https.get(`/vkcms/api/v1/screen/qryWorkInfo?projectCode=${params}`);
};

// 上传大屏PC端图片
export const uploadScreenPc = (data) => {
  return $https.post(`/vkcms/api/v1/story/imgUpload`, data, {
    timeout: 300000 // 5分钟超时
  });
};